// src/app/modules/user/modules/accounts/pages/SubAdminDetailsPage.tsx
import React, {useState, useEffect, useCallback} from 'react'
import {Navigate, Route, Routes, Outlet, useParams} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../../../_metronic/layout/core'
import {ProfileDetailOverview} from '../../components/profile-detail/ProfileDetailOverview'
import {toast} from 'react-toastify'
import axios from 'axios'
import {ProfileDetailHeader} from '../../components/profile-detail/ProfileDetailHeader'
import {API_ENDPOINTS} from '../../../../constants/apiConstants'
import {USER_ROLES} from '../../../../constants/StatusConstants'
import RoutesRoleGuard from '../../components/permissions/RoutesPermissionGuard'
import {FaUser} from 'react-icons/fa'

interface LinkItem {
  title: string
  path: string
  label: string
  allowedRoles: number[]
  icon?: React.ReactNode
}

const SubAdminDetailsPage: React.FC = () => {
  const notifyError = (msg: string) => toast.error(msg)
  // const notifySuccess = (msg: string) => toast.success(msg)

  const {subAdminId} = useParams<{subAdminId: string}>()
  const [userData, setUserData] = useState<any>(null)
  const [loading, setLoading] = useState(true)

  const fetchDetails = useCallback(async () => {
    setLoading(true)
    try {
      const res = await axios.get(API_ENDPOINTS.GET_SPECIFIC_USER(subAdminId))
      setUserData(res.data.data?.user)
    } catch (err) {
      notifyError('Failed to load sub-admin details.')
    } finally {
      setLoading(false)
    }
  }, [subAdminId])

  useEffect(() => {
    fetchDetails()
  }, [fetchDetails])

  const accountBreadCrumbs: PageLink[] = [
    {
      title: 'Sub Admin Details',
      path: `sub-admin-details/${subAdminId}`,
      isSeparator: false,
      isActive: false,
    },
    {title: '', path: '', isSeparator: true, isActive: false},
  ]

  const links: LinkItem[] = [
    {
      title: 'Overview',
      path: `/sub-admin-details/${subAdminId}/overview`,
      label: 'overview',
      allowedRoles: [USER_ROLES.ADMIN, USER_ROLES.DOCTOR],
      icon: <FaUser />,
    },
  ]

  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [isSubmitting, setIsSubmitting] = useState(false)

  const handleEditPress = () => setIsModalOpen(!isModalOpen)

  // const handleSubmit = async (values: any, resetForm: () => void) => {
  //   setIsSubmitting(true)
  //   try {
  //     const resp = await axios.put(API_ENDPOINTS.UPDATE_DOCTOR(userData.id), values)
  //     notifySuccess(resp.data.message)
  //     setUserData((prev: any) => ({
  //       ...prev,
  //       ...values,
  //       full_name: `${values.first_name} ${values.last_name}`,
  //     }))
  //   } catch (err: any) {
  //     notifyError(err.response?.data?.message)
  //   } finally {
  //     setIsModalOpen(false)
  //     setIsSubmitting(false)
  //     resetForm()
  //   }
  // }

  return (
    <>
      <Routes>
        <Route
          element={
            <>
              <ProfileDetailHeader
                user={userData}
                uuid={subAdminId || ''}
                links={links}
                isLoading={loading}
              />
              <Outlet />
            </>
          }
        >
          <Route
            index
            element={<Navigate to={`/sub-admin-details/${subAdminId}/overview`} replace />}
          />

          <Route
            path='overview'
            element={
              <RoutesRoleGuard allowedRoles={[USER_ROLES.ADMIN, USER_ROLES.DOCTOR]}>
                <PageTitle breadcrumbs={accountBreadCrumbs}>Overview</PageTitle>
                <ProfileDetailOverview
                  user={userData}
                  isLoading={loading}
                  onEditPress={handleEditPress}
                />
              </RoutesRoleGuard>
            }
          />

          <Route path='*' element={<Navigate to='/error/404' replace />} />
        </Route>
      </Routes>
    </>
  )
}

export default SubAdminDetailsPage
